import React from 'react'

import { TextField, RaisedButton, FontIcon } from 'material-ui'

const TeamViewHeader = ({ searchFilter, viewMode, onSearchFilterUpdated, onViewModeUpdated }) =>
  <div style={teamHeaderStyle}>
    <TextField
      style={{ marginRight: 10, height: 40 }}
      id="search-filter"
      value={searchFilter}
      hintText={'Search'}
      onChange={(event, value) => onSearchFilterUpdated(value) } />
    <div>
      <RaisedButton
        onTouchTap={() => onViewModeUpdated(TeamViewMode.Tiles)}>
        <FontIcon
          style={iconStyle}
          className="material-icons"
          color={viewMode === TeamViewMode.Tiles ? selectedStyle.color : normalStyle.color}>
          view_module
        </FontIcon>
      </RaisedButton>
      <RaisedButton
        onTouchTap={() => onViewModeUpdated(TeamViewMode.List)}>
        <FontIcon
          style={iconStyle}
          className="material-icons"
          color={viewMode === TeamViewMode.List ? selectedStyle.color : normalStyle.color}>
          list
        </FontIcon>
      </RaisedButton>
    </div>
  </div>

const iconStyle = {
  marginTop: 5
}

const selectedStyle = {
  color: '#4d6f7f'
}

const normalStyle = {
  color: '#ddd'
}

const teamHeaderStyle = {
  padding: 24,
  boxShadow: 'inset 0 -1px 0 1px rgba(0, 0, 0, 0.05)',
  backgroundColor: '#f7f7f7',
  height: 50,
  flexGrow: 0,
  flexShrink: 0,
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'space-between'
}

export const TeamViewMode = {
  List: 'list',
  Tiles: 'tiles'
}

export default TeamViewHeader


// WEBPACK FOOTER //
// ./src/team/TeamHeader.js